import { render, staticRenderFns } from "./Subventionsdaten.vue?vue&type=template&id=726a63ce&scoped=true"
import script from "./Subventionsdaten.vue?vue&type=script&lang=js"
export * from "./Subventionsdaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726a63ce",
  null
  
)

export default component.exports